import { TableCell } from "@mui/material"
import type { FC } from "react"

import { type InventoryPalletTableSort, InventoryPalletTableSortLabel } from "./InventoryPalletTableSortLabel"

import { InventoryPalletGroupsSortField } from "@/graphql/codegen/graphql"

interface InventoryLotTableHeaderCellsProps {
  sort?: InventoryPalletTableSort
  quantityColumnLabel?: string
}

export const InventoryLotTableHeaderCells: FC<InventoryLotTableHeaderCellsProps> = ({
  sort,
  quantityColumnLabel = "Lot UoM",
}) => (
  <>
    <TableCell className='min-w-[80px] whitespace-nowrap'>Lot #</TableCell>
    <TableCell className='min-w-[80px] whitespace-nowrap'>Batch #</TableCell>
    <TableCell className='min-w-[120px] whitespace-nowrap'>
      {sort ? (
        <InventoryPalletTableSortLabel
          field={InventoryPalletGroupsSortField.ExpirationDate}
          label='Remaining Shelf Life'
          sort={sort}
        />
      ) : (
        "Remaining Shelf Life"
      )}
    </TableCell>
    <TableCell className='min-w-[90px] whitespace-nowrap'>Packaging</TableCell>
    <TableCell className='min-w-[60px] whitespace-nowrap'>Units</TableCell>
    <TableCell className='min-w-[70px] whitespace-nowrap'>Pkg UoM</TableCell>
    <TableCell className='min-w-[90px] whitespace-nowrap'>
      {sort ? (
        <InventoryPalletTableSortLabel
          field={InventoryPalletGroupsSortField.LotUom}
          label={quantityColumnLabel}
          sort={sort}
        />
      ) : (
        quantityColumnLabel
      )}
    </TableCell>
  </>
)
